import { v4 as uuidv4 } from "uuid";
import { FieldProps } from "../../utils/functionsInterfaces";
import { displayInfo } from "../../utils/messageToast";

export const handleAddFieldOutsideGroup = (
  setForm: React.Dispatch<React.SetStateAction<any[]>>,
  setButtonSave: React.Dispatch<React.SetStateAction<boolean>>
) => {
  const newField: FieldProps = {
    uuid: uuidv4(),
    id: "",
    name: "",
    isRequired: false,
    isKey: false,
    isNew: true,
    type: "field",
    attribute: "",
    fieldType: "long_text",
    settings: {
      placeholder: `Digite aqui`,
    },
  };
  setForm((prevForm) => [newField, ...prevForm]);
  setButtonSave(true);
  displayInfo("Campo padrão criado!");
};
